import React from 'react'
import PropTypes from 'prop-types'
import { SideBySide } from 'LiveBoard/components/shared/SideBySide'
const cloneDeep = require('lodash/cloneDeep')

const SideBySideRenderer = (props) => {
  const renderSideBySide = (area) => {
    return (
      <SideBySide
        config={cloneDeep(area)}
        isMobile={props.isMobile}
        index={area.key}
        themeColorHex={props.themeColorHex}
        onItemClick={props.onItemClick} />
    )
  }
  return renderSideBySide(props.area)
}

SideBySideRenderer.propTypes = {
  area: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  themeColorHex: PropTypes.string,
  onItemClick: PropTypes.func.isRequired
}

export default SideBySideRenderer